export class CanaisComunicacaoWhatsAppDocumento {
  public extension: string;
  public phone: string;
  public document: string;
  public fileName: string;
  public guidclientenapis: string;

  constructor() { }
}
